var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 47,
    viewBox: "0 0 62 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8863 3.97826V9.20793C56.691 9.18296 56.4962 9.16265 56.3236 9.14655C56.1283 9.12833 55.9544 9.1149 55.8293 9.10602C55.7667 9.10157 55.7161 9.09826 55.681 9.09604L55.6403 9.09353L55.6294 9.09288L55.6264 9.09271L55.6256 9.09266L55.6253 9.09265L55.6252 9.09264L55.5968 9.59184L55.6252 9.09264L55.6112 9.09185L55.5973 9.09184L22.9615 9.06499L20.5496 3.06494H55.9716C56.4775 3.06494 56.8863 3.47337 56.8863 3.97826Z",
    fill: "#2898FF",
    stroke: "#2898FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6954 9.93687L21.9473 10.5633L22.6224 10.5639L55.5665 10.591L55.587 10.5922C55.6186 10.5942 55.6652 10.5972 55.7235 10.6013C55.8404 10.6096 56.0028 10.622 56.1844 10.6389C56.5512 10.673 56.9462 10.7208 57.2097 10.7779C59.3973 11.4056 61 13.4141 61 15.7887V39.3005H1V2.99907C1 1.89312 1.89321 1 2.99688 1H18.1033L18.9939 3.21601L18.9939 3.21608L21.6954 9.93687ZM1 43.5382H61V44.0009C61 45.1045 60.1053 46 59.0012 46H2.99688C1.89363 46 1 45.1054 1 44.0009V43.5382Z",
    fill: "white",
    stroke: "#2898FF",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1f973f0384389fcb368889deacf73d1c.svg";
export { ForwardRef as ReactComponent };